var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71652 7.42864C6.47428 7.42864 7.201 7.12762 7.73682 6.5918C8.27264 6.05598 8.57366 5.32926 8.57366 4.5715C8.57366 3.81374 8.27264 3.08701 7.73682 2.55119C7.201 2.01537 6.47428 1.71436 5.71652 1.71436C4.95876 1.71436 4.23203 2.01537 3.69621 2.55119C3.16039 3.08701 2.85938 3.81374 2.85938 4.5715C2.85938 5.32926 3.16039 6.05598 3.69621 6.5918C4.23203 7.12762 4.95876 7.42864 5.71652 7.42864Z",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.572266 15.4285H10.858V14.8091C10.8507 14.1182 10.7045 13.4358 10.4282 12.8025C10.1518 12.1692 9.751 11.5979 9.24948 11.1226C8.74796 10.6473 8.15599 10.2777 7.50877 10.0358C6.86156 9.79384 6.1723 9.6845 5.48198 9.71426C4.16802 9.7766 2.92762 10.339 2.01483 11.2862C1.10204 12.2334 0.585954 13.4937 0.572266 14.8091V15.4285Z",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 7.42864C11.0429 7.42864 11.7696 7.12762 12.3055 6.5918C12.8413 6.05598 13.1423 5.32926 13.1423 4.5715C13.1423 3.81374 12.8413 3.08701 12.3055 2.55119C11.7696 2.01537 11.0429 1.71436 10.2852 1.71436",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.144 15.4287H15.4297V14.8092C15.4175 13.6522 15.0163 12.5329 14.2908 11.6315C13.5652 10.7302 12.5574 10.0992 11.4297 9.84009",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.861e2c21da3168ee2b9798a1024f9048.svg";
export { ForwardRef as ReactComponent };